import { ViewType, ViewObject } from '../base';

import { dataService } from '../../data';
import { Payment } from '../objects/payment';

/****************************/
/* CLASS VIEW               */
/****************************/

export class _PaymentView extends ViewObject<Payment> {

    private get payment(): Payment {
        return this.object;
    }

    constructor(object: Payment, data: dataService) {
        super(object, data);
    }

    private RefreshView(targets: string[]): void {
        if (targets.includes('PAYMENT')) {
            this.DoRefreshView();
        }
    }

    override doRegister(): void {
        const weakref = new WeakRef(this);

        for (const _subscription of this._subscriptions) {
            _subscription.unsubscribe();
        }
        this._subscriptions = [];

        this._subscriptions.push(
            this.payment.OnRefresh.subscribe((targets: string[]) => {
                const self = weakref.deref();
                if (self) {
                    self.RefreshView(targets);
                }
            })
        );
    }
}

/****************************/
/* PROXY VIEW               */
/****************************/

export type PaymentView = ViewType<_PaymentView, Payment>;

export function PaymentViewProxy(object: Payment, data: dataService): PaymentView {
    return new _PaymentView(object, data).Proxy as PaymentView;
}
